import router from './routes';
import { firebaseAuth } from '../plugins/firebase';
import store from '../store';

router.beforeEach((to, from, next) => {
  firebaseAuth.onAuthStateChanged(async user => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (requiresAuth) {
      if (user) {
        if (!from.name) {
          await store.dispatch('auth/getAccount', user.uid);
          next();
        } else next();
      } else {
        next({ name: 'landing' });
      }
    } else {
      next();
    }
  });
});
